import AuthContentWrapper from "./components/AuthContentWrapper";
import { C2Text, T1Text } from "../../common/components/text/CustomText";
import { Column, SizedBox } from "../../common/components/CommonBaseComponents";
import { useNavigate, useSearchParams } from "react-router-dom";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import { useEffect, useState } from "react";
import CustomPopup from "../../common/components/popup/CustomPopup";
import AuthService from "../../service/AuthService";
import { Theme } from "../../common/Theme";

function AuthMessagePage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const authKeyNum = searchParams.get("authKeyNum");
    const service = new AuthService();

    // error popup
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    useEffect(() => {
        if (authKeyNum) {
            service.verifyJoinEmail({ authKeyNum }).catch((error) => {
                setPopupMessage(error.message);
                setIsPopupOpened(true);
            });
        }
    }, [authKeyNum, service]);

    return (
        <AuthContentWrapper contentPadding={"62px 60px"}>
            <Column justifyContent={"center"}>
                <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                    Laundry Crew Admin
                </T1Text>
                <SizedBox height={"10px"} />
                <C2Text fontColor={Theme.color.gray500}>Laundry Crew account created</C2Text>
                <SizedBox height={"44px"} />
                <C2Text fontColor={Theme.color.gray500} textAlign={"center"}>
                    Please sign in from the service you initially signed up.
                </C2Text>
                <SizedBox height={"32px"} />
                <FullWidthButton onClick={() => navigate("/auth/login")} text={"Ok"} />
            </Column>
            <CustomPopup isOpen={isPopupOpened} onConfirm={() => setIsPopupOpened(false)} message={popupMessage} />
        </AuthContentWrapper>
    );
}

export default AuthMessagePage;
